import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { FocusAreas } from './components/FocusAreas';
import { PortfolioSection } from './components/PortfolioSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-avm-bg text-avm-text font-sans selection:bg-avm-accent selection:text-avm-bg" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <FocusAreas data-id="element-5" />
        <PortfolioSection data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}